"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _hyphenateStyleName = _interopRequireDefault(require("./hyphenateStyleName"));

var _removeStyle = _interopRequireDefault(require("./removeStyle"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var _default = function _default(node, property, value) {
  var css = '';
  var props = property;

  if (typeof property === 'string') {
    if (value === undefined) {
      throw new Error('value is undefined');
    }

    (props = {})[property] = value;
  }

  if (_typeof(props) === 'object') {
    for (var key in props) {
      if (Object.prototype.hasOwnProperty.call(props, key)) {
        if (!props[key] && props[key] !== 0) {
          (0, _removeStyle.default)(node, (0, _hyphenateStyleName.default)(key));
        } else {
          css += "".concat((0, _hyphenateStyleName.default)(key), ":").concat(props[key], ";");
        }
      }
    }
  }

  node.style.cssText += ";".concat(css);
};

exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/dom-lib/lib/style/addStyle.js
// module id = 1701
// module chunks = 0